import React, {useCallback, useContext, useState} from 'react';

import {MessageContext} from 'src/contexts/message-context';

import Button from '@pb/kit-component-button';
import {Dialog, DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {Message} from '@pb/kit-component-message';
import {useShown} from '@pb/kit-hooks-use-shown';

import {useDeleteSsoDraft} from '../hooks/useDeleteSsoDraft';

type Props = {
    draftId: number,
    onDeleted: () => void,
};

export const DeleteSsoDraft = ({draftId, onDeleted}: Props) => {
    const {shown, onClick, onClose} = useShown();
    const {setSuccessMessage} = useContext(MessageContext);
    const [errorMessage, setErrorMessage] = useState('');
    const onSuccess = useCallback(() => {
        setSuccessMessage('Customer Admin SSO settings were successfully deleted');
        onClose();
        onDeleted();
    }, [onClose, onDeleted, setSuccessMessage]);
    const {event, busy} = useDeleteSsoDraft({draftId, onSuccess, onFail: setErrorMessage});
    const onDelete = useCallback(() => event(), [event]);

    return (
        <>
            <Button variant="Type.SECONDARY" colorVariant="ERROR" onClick={onClick}>
                Clean Progress
            </Button>
            <Dialog shown={shown} setShown={onClose} wrapperProps={{style: {width: 440}}}>
                <DialogHeader onClose={onClose}>Clean Customer Admin Settings</DialogHeader>
                <DialogMain style={{padding: 24}}>
                    {errorMessage ? <Message color="error">{errorMessage}</Message> : null}
                    Are you sure you want to clean the customer admin SSO setup progress?
                </DialogMain>
                <DialogFooter>
                    <Group>
                        <Button variant="Type.PRIMARY" busy={busy} onClick={onDelete}>Clean Progress</Button>
                        <Button variant="Type.SECONDARY" onClick={onClose}>Cancel</Button>
                    </Group>
                </DialogFooter>
            </Dialog>
        </>
    );
};
